import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import HeaderComponent from "components/card/HeaderComponent";
import InboxMessageCard from "./InboxMessageCard";
import SearchBar from "components/search/SearchBar";
import SelectOption from "components/select/SelectOption";
import {
  getPsTypeList
} from "../../../../../../redux/optionlist/optionlistState";

const MessageListPanel = ({
  messages,
  selectedMessage,
  onSelect,
  starredMessages,
  onToggleStar,
  doGetPsTypeList,
  psTypeList = [],
}) => {
  const [selectedType, setSelectedType] = useState("all");
  const [searchKeyword, setSearchKeyword] = useState("");
  const [filteredMessages, setFilteredMessages] = useState(messages);

  useEffect(() => {
    if (doGetPsTypeList) {
      doGetPsTypeList();
    }
  }, [doGetPsTypeList]);

  // Filter messages based on type and search
  useEffect(() => {
    let filtered = messages || [];
    
    // Filter by type
    if (selectedType !== "all") {
      filtered = filtered.filter(ticket => ticket.tic_category_id === selectedType);
    }
    
    // Filter by search keyword
    if (searchKeyword && searchKeyword.trim() !== "") {
      const keyword = searchKeyword.toLowerCase().trim();
      filtered = filtered.filter(ticket => 
        ticket.tic_code?.toLowerCase().includes(keyword) ||
        ticket.tic_title?.toLowerCase().includes(keyword)
      );
    }
    
    setFilteredMessages(filtered);
  }, [selectedType, messages, searchKeyword]);

  const handleTypeChange = (value) => {
    setSelectedType(value);
  };

  // This receives { keyword: "search text" } from SearchBar
  const handleSearchChange = ({ keyword }) => {
    setSearchKeyword(keyword || "");  // Extract the keyword from the object
  };

  return (
    <HeaderComponent
      title="Messages"
      description={`${filteredMessages?.length || 0} messages`}
      bgcolor="gradient light-indigo"
    >
      <div className="space-y-3 mt-4">
        <SearchBar 
          placeholder="Search message..."
          value={searchKeyword}
          searchHandler={handleSearchChange}
        />
        
        <SelectOption
          placeholder="Filter by Type"
          options={psTypeList} 
          onChange={handleTypeChange}
          value={selectedType}
        />

        <div className="bg-slate-200 h-px w-full my-4"></div>

        <div className="overflow-y-auto h-[60vh] pr-2">
          <InboxMessageCard
            messages={filteredMessages}       
            selectedMessage={selectedMessage}
            onClick={onSelect}               
            starredMessages={starredMessages}
            onToggleStar={onToggleStar}
          />
        </div>
      </div>
    </HeaderComponent>
  );
};

const mapStateToProps = (state) => ({
  psTypeList: state.optionlist.psTypeList?.items, 
});

const mapDispatchToProps = (dispatch) => ({
  doGetPsTypeList: (data) => dispatch(getPsTypeList(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MessageListPanel);